import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface FreePlanNoticeProps {
    className?: string;
    showLimits?: boolean;
    onTermsClick?: () => void;
}

/** Keep the free offer consistent at discovery, enrollment, and account settings. */
export function FreePlanNotice({ className = '', showLimits = true, onTermsClick }: FreePlanNoticeProps) {
    const { t } = useTranslation();

    return (
        <div className={`free-plan-notice space-y-2 text-sm leading-relaxed ${className}`}>
            {showLimits && <p>{t('freePlan.limits')}</p>}
            <p>{t('freePlan.notice')}</p>
            <p>
                {t('freePlan.noAutoCharge')}{' '}
                <Link to="/terms#free-plan" onClick={onTermsClick} className="font-medium underline underline-offset-2">
                    {t('freePlan.termsLink')}
                </Link>
            </p>
        </div>
    );
}
